import React from 'react';
import ReactDOM from 'react-dom';
import { Button } from 'reactstrap';
import { WIDGET_BUTTON_CLASS } from '../BSLAConstants';
import { DateTime } from 'luxon';
import jspdf from 'jspdf';
import { BSLA_LOGO_BASE64 } from '../images/bsla_logo';

const ScreenshotButton: React.FC<{ view: __esri.MapView | __esri.SceneView }> = (props) => {
    // logo size in inches
    const logoWidth = 0.683 * 2; // 1024/1500
    const logoHeight = 0.189 * 2; // 284/300

    const onClick = async (evt: React.MouseEvent<HTMLButtonElement>) => {
        evt.preventDefault();
        const isLandscape = props.view.height <= props.view.width ? true : false;

        const options = {
            height: isLandscape ? props.view.height * window.devicePixelRatio : (11 / 8.5) * props.view.width * window.devicePixelRatio,
            width: isLandscape ? (11 / 8.5) * props.view.height * window.devicePixelRatio : props.view.width * window.devicePixelRatio
        } as __esri.MapViewTakeScreenshotOptions;

        try {
            const screenshot = await props.view.takeScreenshot(options);
            const doc = new jspdf(isLandscape ? 'l' : undefined, 'in', 'letter');

            doc.addImage(screenshot.dataUrl, 0, 0, isLandscape ? 11 : 8.5, isLandscape ? 8.5 : 11);

            doc.addImage(BSLA_LOGO_BASE64, 0.25, (isLandscape ? 8.5 : 11) - logoHeight - 0.45, logoWidth, logoHeight);

            const now = DateTime.local();
            doc.setTextColor(128);
            doc.setFontSize(9);
            doc.text(0.25, isLandscape ? 8.25 : 10.75, `${now.toLocaleString(DateTime.DATE_MED)}`);
            doc.save(`BSLA_Print_${DateTime.local().toSeconds()}.pdf`);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <Button {...WIDGET_BUTTON_CLASS} size="sm" title="Export PDF" onClick={onClick}>
            <span className="esri-icon-printer" />
        </Button>
    );
};

const BSLAScreenshotWidget = (props: { view: __esri.MapView | __esri.SceneView }) => {
    const node = document.createElement('div');
    ReactDOM.render(<ScreenshotButton view={props.view} />, node);
    return node;
};

export default BSLAScreenshotWidget;
